/**
 * PIP Workflow Machine Config
 *
 * Spec: Documentation/Specification/04_Processes/application-specific/hr/PerformanceImprovementPlanProcess.md
 * States: draft → active → reviewScheduled → reviewComplete → completed/extended/terminated
 */
export const pipConfig = {
    id: 'pip',
    initial: 'draft',
    states: {
        draft: {
            on: { ACTIVATE: { target: 'active', guard: 'reviewPeriodElapsed' } },
        },
        active: {
            entry: { type: 'activatePIP' },
            on: { SCHEDULE_REVIEW: 'reviewScheduled' },
        },
        reviewScheduled: {
            entry: { type: 'scheduleReview' },
            on: { REVIEW_COMPLETE: 'reviewComplete' },
        },
        reviewComplete: {
            on: [
                { target: 'completed', guard: 'targetsMet' },
                { target: 'extended', guard: 'targetsNotMet' },
            ],
        },
        completed: {
            entry: { type: 'completePIP' },
            type: 'final',
        },
        extended: {
            entry: { type: 'extendPIP' },
            on: { SCHEDULE_REVIEW: 'reviewScheduled' },
        },
        terminated: {
            entry: { type: 'terminateEmployee' },
            type: 'final',
        },
    },
};
//# sourceMappingURL=pip.js.map